export default {
  login: {
    title: 'Mag-sign In',
    username: 'Username',
    phone: 'Numero ng Telepono',
    phoneCode: 'Code',
    email: 'Email',
    password: 'Password',
    captcha: 'Captcha',
    loading: 'Naglo-load...',
    rememberMe: 'Tandaan ako',
    forgotPassword: 'Nakalimutan ang Password?',
    loginButton: 'Mag-sign In',
    contactUs: 'Makipag-ugnayan？',
    noAccount: 'Wala pang account?',
    registerNow: 'Mag-sign Up',
    or: 'O',
    orSignInWith: 'O mag-sign in gamit ang',
    methodUsername: 'Username',
    methodPhone: 'Telepono',
    methodEmail: 'Email',
    usernameRequired: 'Kailangan ang username',
    phoneRequired: 'Kailangan ang numero ng telepono',
    emailRequired: 'Kailangan ang email',
    passwordRequired: 'Kailangan ang password',
    captchaRequired: 'Kailangan ang captcha',
    resetPassword: 'I-reset ang Password',
    resetStep1Hint: 'Ilagay ang iyong numero ng telepono o email upang makatanggap ng verification code.',
    useEmailInstead: 'Gumamit ng email',
    usePhoneInstead: 'Gumamit ng telepono',
    sendCode: 'Magpadala ng Code',
    resetStep2Hint: 'Ang verification code ay naipadala na sa',
    verificationCode: 'Verification Code',
    verificationCodeRequired: 'Kailangan ang verification code',
    resendIn: 'Ipadala muli sa',
    resendCode: 'Ipadala Muli ang Code',
    verify: 'I-verify',
    resetStep3Hint: 'Itakda ang iyong bagong password.',
    newPassword: 'Bagong Password',
    confirmPassword: 'Kumpirmahin ang Password',
    passwordMinLength: 'Ang password ay dapat na hindi bababa sa 6 na character',
    confirmPasswordRequired: 'Pakikumpirma ang iyong password',
    passwordMismatch: 'Ang mga password ay hindi tugma',
    resetPasswordBtn: 'I-reset ang Password',
    back: 'Bumalik',
    // Format validation
    emailFormat: 'Hindi wastong format ng email',
    // Toast messages
    loginSuccess: 'Matagumpay ang pag-login',
    loginFailed: 'Nabigo ang pag-login',
    signInWithGoogle: 'Mag-sign in gamit ang Google+',
    codeSent: 'Naipadala ang verification code',
    sendCodeFailed: 'Nabigo ang pagpapadala ng code',
    invalidCode: 'Hindi wastong verification code',
    resetSuccess: 'Matagumpay na na-reset ang password',
    resetFailed: 'Nabigo ang pag-reset ng password'
  }
};
